import { render } from "./ServiciosColectivos.vue?vue&type=template&id=04d87117&ts=true"
import script from "./ServiciosColectivos.vue?vue&type=script&lang=ts"
export * from "./ServiciosColectivos.vue?vue&type=script&lang=ts"

import "./ServiciosColectivos.vue?vue&type=style&index=0&id=04d87117&lang=css"

import exportComponent from "/tmp/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__